import {
  SR_API_ACTION_GET_LISTING_LIST,
} from 'api/actionTypes';

export default async function getTotalListingsCount({ state, apiClient }) {
  const params = {
    page: 0,
    count: 1,
    onlyCount: true,
    filters: {
      marketId: state.get(['currentUser', 'searchFilters', 'marketId']),
    },
  };

  const currentTotalListingsCount = state.get(['listings', 'totalListingsCount']);
  if (currentTotalListingsCount) {
    return currentTotalListingsCount;
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_LISTING_LIST,
    state: state,
    queryId: 'totalListingsCount',
    payload: params,
    onSuccess({ total }) {
      state.set(['listings', 'totalListingsCount'], total);
    },
  });
}
